// export const APP_MODE = import.meta.env.MODE; // ["production","development"]

export const ProjectUrl = "https://api.alpshop.in/";
// export const ProjectUrl = "https://alp-be.hkstest.uk/";
// export const ProjectUrl =
//   "https://1a97-2401-4900-1c67-20df-85f2-ef55-44b2-a6fc.ngrok-free.app/";
